module.exports = __webpack_public_path__ + "img/case-static-resource.04c60df9.png";